import React from 'react';
import { translate } from 'react-i18next';

import TimeSheetNavItem from 'components/timesheets/TimeSheetNavItem.js';

class TimeSheetNav extends React.Component {
  render() {
    const previousRender = !!(
      this.props.previousSheets != null && this.props.previousSheets.length > 0
    );
    const currentRender = this.props.currentSheet != null;
    return (
      <div>
        <nav className="secondary-nav">
          <h2>{this.props.t('TimeSheetNav.timesheets').toUpperCase()}</h2>
          <ul>
            <TimeSheetNavItem
              shouldRender={currentRender}
              onClickHandler={this.props.onClickHandler.bind(this)}
              activePage={this.props.activePage}
              section="currentTimeSheet"
              text={this.props.t('TimeSheetNav.current_timesheet')}
            />
            <TimeSheetNavItem
              shouldRender={previousRender}
              onClickHandler={this.props.onClickHandler.bind(this)}
              activePage={this.props.activePage}
              section="previousTimeSheet"
              text={this.props.t('TimeSheetNav.previous_timesheets')}
            />
          </ul>
        </nav>
      </div>
    );
  }
}

export default translate()(TimeSheetNav);
